import {useEffect, useMemo} from 'react';
import {useSelector} from 'react-redux';
import OneAppUserAPI from '@/user/user-oneapp-api';
import {HEALTHIESTYOU_BUNDLE_IDENTIFIER} from '@/config';

function resolveDataTheme({branding, isOneApp, isPLI, isHealthiestYou}) {
    if (isOneApp) {
        return branding?.data_theme || (isHealthiestYou ? 'teladoc' : '');
    }

    return isPLI && !isHealthiestYou ? 'pli' : 'teladoc';
}

export default function useDataTheme() {
    const {branding, isOneApp} = useSelector(state => state.app);
    const isPLI = useMemo(() => OneAppUserAPI.isPLIBrand(), []);
    const isHealthiestYou = useMemo(
        () =>
            OneAppUserAPI.getBundleIdentifier() ===
            HEALTHIESTYOU_BUNDLE_IDENTIFIER,
        []
    );

    useEffect(() => {
        const dataTheme = resolveDataTheme({
            branding,
            isOneApp,
            isPLI,
            isHealthiestYou,
        });

        if (dataTheme) {
            document.documentElement.setAttribute('data-theme', dataTheme);
        }
    }, [branding, isOneApp, isPLI, isHealthiestYou]);
}
